import { render, staticRenderFns } from "./SimilarWords.vue?vue&type=template&id=01b1ba62&scoped=true&"
import script from "./SimilarWords.vue?vue&type=script&lang=js&"
export * from "./SimilarWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1ba62",
  null
  
)

export default component.exports